import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

interface Testimonial {
  name: string;
  quote: string;
}

@Component({
  imports: [TranslocoDirective],
  selector: 'app-home-trusted',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './trusted.html',
})
export class Trusted {
  protected readonly testimonials: Testimonial[] = [
    {
      name: 'Tenby International School Setia Ecohill',
      quote:
        'This was a great and interactive learning experience. Our students thoroughly enjoyed all the activities.',
    },
    {
      name: 'Wesley Methodist School Bandar Seri Coalfields',
      quote:
        'We would also like to extend our sincere thanks to you and your team for all the hard work and wonderful arrangements. Our students truly enjoyed the programme and had a great time learning through the fun, hands-on activities.',
    },
  ];
}
